<template>
  <section>
    <div>
      <v-dialog
        max-width="480px"
        min-width="240px"
        Modal
        persistent
        v-model="payload.newformdialog"
      >
        <v-carousel>
          <v-carousel-item>
            <v-sheet
              class="d-flex flex-column"
              style="padding: 20px"
              color="blue"
              height="100%"
              tile
            >
              <div align="center" class="display-2">
                {{ $t("newForm.orderForm.title") }}
              </div>
              <div>&nbsp;</div>
              <i>{{ $t("newForm.orderForm.subtitle") }}</i>
              <ul>
                <li>
                  {{ $t("newForm.orderForm.text1") }}
                </li>
                <li>{{ $t("newForm.orderForm.text2") }}</li>
                <li>{{ $t("newForm.orderForm.text3") }}</li>
              </ul>
              <v-spacer></v-spacer>
              <v-btn @click="formaction()" text>{{
                $t("newForm.orderForm.submitButton")
              }}</v-btn>
              <v-btn @click="cancelaction()" text>{{
                $t("newForm.cancelButton")
              }}</v-btn>
              <div>&nbsp;</div>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet
              class="d-flex flex-column"
              style="padding: 20px"
              color="red"
              height="100%"
              tile
            >
              <div align="center" class="display-2">
                {{ $t("newForm.catelogue.title") }}
              </div>
              <div>&nbsp;</div>
              <i>{{ $t("newForm.catelogue.subtitle") }}</i>
              <ul>
                <li>
                  {{ $t("newForm.catelogue.text1") }}
                </li>
                <li>
                  {{ $t("newForm.catelogue.text2") }}
                </li>
              </ul>
              <v-spacer></v-spacer>
              <v-btn @click="catalogueaction()" text>{{
                $t("newForm.catelogue.submitButton")
              }}</v-btn>
              <v-btn @click="cancelaction()" text>{{
                $t("newForm.cancelButton")
              }}</v-btn>
              <div>&nbsp;</div>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-dialog>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";
import router from "../router/router";
import { analytics, setLocale } from "../services/firebase";

export default {
  name: "newformroute",
  data() {
    return {
      name: "",
      showMessage: false,
      locale: "Deutsch",
    };
  },
  props: ["payload"],
  components: {},
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
  },
  methods: {
    nextaction: function() {
      this.typeSelected(this.$store.state.newformroute.type);
    },
    formaction: function() {
      if (!this.$store.state.profile.isSigned) {
        router.push("/");
      } else {
        this.$store.state.newformroute.newformdialog = false;
        // console.log("3");
        analytics.logEvent("create_order_form", {
          isCreated: true,
        });
        this.typeSelected("Ordering form");
      }
    },
    catalogueaction: function() {
      if (!this.$store.state.profile.isSigned) {
        router.push("/");
      } else {
        this.$store.state.newformroute.newformdialog = false;
        // console.log("4");

        analytics.logEvent("create_catalogue", {
          isCreated: true,
        });
        this.typeSelected("Catalogue");
      }
    },
    cancelaction: function() {
      if (!this.$store.state.profile.isSigned) {
        router.push("/");
      } else {
        this.cancelNewForm();
      }
    },
    typeSelected: function(type) {
      var curcallback = this.$store.state.curcallback;
      if (curcallback) {
        var c = curcallback;
        this.$store.dispatch("setCurCallback", null);
        c(type);
      } else {
        this.$store.state.newformroute.newformdialog = false;
        // console.log("4");
      }
    },
    cancelNewForm: function() {
      //curcallback = null;
      this.$store.state.newformroute.newformdialog = false;
      this.$store.dispatch("setCurCallback", null);
      //router.push("/admin");
    },
  },
  mounted() {
    //controller.resume();
    setLocale();
    this.$store.dispatch("setOverlay", false);
    // console.log(this.payload.newformdialog);
  },
};
</script>
